import type { ReactNode } from "react";

import { cn } from "~/lib/utils";

/** Full-height app navigation and page content. */
export function AppShellBody(props: { children: ReactNode; className?: string }) {
  return (
    <div
      className={cn("flex min-h-0 min-w-0 flex-1 overflow-hidden", props.className)}
      data-slot="app-shell-body"
    >
      {props.children}
    </div>
  );
}
